import React, { useState } from 'react';
import {
  IconButton,
  Menu,
  MenuItem,
  ListItemIcon,
  Typography,
} from '@mui/material';
import MoreVertIcon from '@mui/icons-material/MoreVert';

const TableActionsMenu = ({ options }) => {
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  return (
    <>
      <IconButton onClick={handleClick} size="small">
        <MoreVertIcon />
      </IconButton>
      <Menu
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        PaperProps={{
          style: {
            minWidth: 150,
            borderRadius: 8,
            boxShadow: '0px 4px 10px rgba(0,0,0,0.15)',
          },
        }}>
        {options.map((option, index) => (
          <MenuItem
            key={index}
            disabled={option.disabled || false}
            onClick={() => {
              handleClose();
              option.onClick();
            }}>
            {option.icon && <ListItemIcon>{option.icon}</ListItemIcon>}
            <Typography variant="body2">{option.label}</Typography>
          </MenuItem>
        ))}
      </Menu>
    </>
  );
};

export default TableActionsMenu;
